<template>
    <v-content>
        <section>
            <v-parallax src="static/hero.jpeg" height="600">
                <v-layout column align-center justify-center class="white--text">
                    <img src="static/dslogo.png" alt="data chester logo" height="200">
                    <h1 class="white--text mb-2 display-1 text-xs-center">Data Chester Inc.</h1>
                    <router-link class="v-btn blue lighten-2 mt-5" :to="{ name: 'Signup'}">
                        Get Started
                    </router-link>
                </v-layout>
            </v-parallax>
        </section>

        <business/>

        <section>
            <v-parallax src="static/FlushingCommons2.jpg" height="380">
                <v-layout column align-center justify-center>
                    <div class="headline white--text mb-3 text-xs-center">
                        <b style="color: gold">Kick start your business with our custom software and beautiful
                            website today</b>
                    </div>
                    <em style="color: black; font-size: medium; background-color: gold">Sign up to find out more
                        about our services ...</em>
                    <router-link class="v-btn blue lighten-2 mt-5" :to="{ name: 'Signup'}">
                        Get Started
                    </router-link>
                </v-layout>
            </v-parallax>
        </section>
        <company-info/>
    </v-content>
</template>
<script>
    import CompanyInfo from '@/components/layout/sections/CompanyInfo'
    import Business from '@/components/layout/sections/Business'

    export default {
        name: "Home",
        components: {
            CompanyInfo, Business
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/home/Home.vue